/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import {
  CONSOLE_RESPONSE_CODE_ERROR,
  CONSOLE_RESPONSE_CODE_FAIL,
  CONSOLE_RESPONSE_CODE_FORBIDDEN,
  CONSOLE_RESPONSE_CODE_NOT_FOUND,
  CONSOLE_RESPONSE_CODE_NO_CONTENT,
  CONSOLE_RESPONSE_CODE_SUCCESS,
  CONSOLE_RESPONSE_CODE_UNAUTHORIZED,
  CONSOLE_RESPONSE_MESSAGE_ERROR,
  CONSOLE_RESPONSE_MESSAGE_FAIL,
  CONSOLE_RESPONSE_MESSAGE_FORBIDDEN,
  CONSOLE_RESPONSE_MESSAGE_NOT_FOUND,
  CONSOLE_RESPONSE_MESSAGE_NO_CONTENT,
  CONSOLE_RESPONSE_MESSAGE_SUCCESS,
  CONSOLE_RESPONSE_MESSAGE_UNAUTHORIZED,
} from './ConsoleResponse.entity.constant';

/**
 * The console response.
 * @export
 */
export type EntityConsoleResponse = io.TypeOf<typeof ConsoleResponse>;

/**
 * The console response.
 * @export
 */
export const ConsoleResponse = io.type(
  {
    code: io.union([
      io.literal(CONSOLE_RESPONSE_CODE_SUCCESS),
      io.literal(CONSOLE_RESPONSE_CODE_NO_CONTENT),
      io.literal(CONSOLE_RESPONSE_CODE_FAIL),
      io.literal(CONSOLE_RESPONSE_CODE_UNAUTHORIZED),
      io.literal(CONSOLE_RESPONSE_CODE_FORBIDDEN),
      io.literal(CONSOLE_RESPONSE_CODE_NOT_FOUND),
      io.literal(CONSOLE_RESPONSE_CODE_ERROR),
    ]),
    message: io.union([
      io.literal(CONSOLE_RESPONSE_MESSAGE_SUCCESS),
      io.literal(CONSOLE_RESPONSE_MESSAGE_NO_CONTENT),
      io.literal(CONSOLE_RESPONSE_MESSAGE_FAIL),
      io.literal(CONSOLE_RESPONSE_MESSAGE_UNAUTHORIZED),
      io.literal(CONSOLE_RESPONSE_MESSAGE_FORBIDDEN),
      io.literal(CONSOLE_RESPONSE_MESSAGE_NOT_FOUND),
      io.literal(CONSOLE_RESPONSE_MESSAGE_ERROR),
    ]),
  },
  `ConsoleResponse`,
);
